import {
  Box,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import React from "react";
import { useTranslation } from "react-i18next";
import { useStyles } from "./styles";

type CatalogFieldControlProps = {
  labelKey: string;
  value: string;
  options?: [string, string][];
  placeholderKey?: string;
  onChange?: (value: string) => void;
};

export const CatalogFieldControl = ({
  labelKey,
  value,
  options,
  placeholderKey,
  onChange,
}: CatalogFieldControlProps) => {
  const { t } = useTranslation();
  const styles = useStyles();

  return (
    <Box className={styles.field}>
      <Typography className={styles.label}>{t(labelKey)}</Typography>
      {options ? (
        <FormControl fullWidth className={styles.selectControl}>
          <Select
            className={styles.select}
            variant="outlined"
            displayEmpty
            value={value}
            IconComponent={KeyboardArrowDownIcon}
            onChange={(event: SelectChangeEvent) => onChange?.(event.target.value)}
            renderValue={(selected) => {
              if (!selected) {
                return (
                  <span className={styles.selectPlaceholder}>
                    {placeholderKey ? t(placeholderKey) : ""}
                  </span>
                );
              }
              const option = options.find(
                ([optionValue]) => optionValue === selected
              );
              return (
                <span className={styles.selectValue}>
                  {option ? t(option[1]) : selected}
                </span>
              );
            }}
          >
            {options.map(([optionValue, optionLabelKey]) => (
              <MenuItem key={optionValue} value={optionValue}>
                {t(optionLabelKey)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : (
        <TextField
          className={styles.input}
          fullWidth
          variant="outlined"
          value={value}
          placeholder={placeholderKey ? t(placeholderKey) : ""}
          onChange={(event) => onChange?.(event.target.value)}
        />
      )}
    </Box>
  );
};
